// extracted by mini-css-extract-plugin
module.exports = {"stay":"CollectionContainer_stay__zmK_c","collectionTag":"CollectionContainer_collectionTag__20qlu","isDesktop":"CollectionContainer_isDesktop__3RfVZ"};